'use strict';

var addressHelpers = require('./address');
var formHelpers = require('./formErrors');
var summaryHelpers = require('./summary');
var scrollAnimate = require('../components/scrollAnimate');
var shippingListTimer = null;
var floatingLabel = require('../components/floatingLabel');

$('.multi-shipping').remove();

function getValidCountries() {
    var validCountries = $('#validNonGECountryCodes').val();
    var validCountriesObj;
    if (validCountries) {
        try {
            validCountriesObj = JSON.parse(validCountries);
        } catch (error) {
            validCountriesObj = null;
            console.error(error); // eslint-disable-line no-console
        }
    }
    return validCountriesObj;
}

function isValidCountry(countryCode) {
    var isValid = false;

    if (countryCode) {
        isValid = true;

        var validCountriesObj = getValidCountries();
        if (validCountriesObj && !validCountriesObj[countryCode]) {
            isValid = false;
        }
    }

    return isValid;
}

function getGlobaleCountry(countryCode) {
    var globaleCountry = null;

    if (countryCode) {
        var validCountriesObj = getValidCountries();
        if (validCountriesObj
        && validCountriesObj[countryCode]
        && validCountriesObj[countryCode].isOperatedByGlobalE) {
            globaleCountry = validCountriesObj[countryCode];
        }
    }

    return globaleCountry;
}

/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector(productLineItem, shipping, order, customer) {
    var uuidEl = $('input[value=' + productLineItem.UUID + ']');
    var shippings = order.shipping;

    var form;
    var $shippingAddressSelector;
    var hasSelectedAddress = false;

    if (uuidEl && uuidEl.length > 0) {
        form = uuidEl[0].form;
        $shippingAddressSelector = $('.addressSelector', form);
    }

    if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
        $shippingAddressSelector.empty();
        // Add New Address option
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order
        ));

        if (customer.addresses && customer.addresses.length > 0) {
            $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses,
                false,
                order
            ));

            customer.addresses.forEach(function (address) {
                var isSelected = shipping.matchingAddressId === address.ID;
                $shippingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress(
                        { UUID: 'ab_' + address.ID, shippingAddress: address },
                        isSelected,
                        order,
                        { isPreferred: customer.preferredAddress.ID === address.ID }
                    )
                );
            });
        }
        // Separator -
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, { className: 'multi-shipping' }
        ));
        shippings.forEach(function (aShipping) {
            var isSelected = shipping.UUID === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            var addressOption = addressHelpers.methods.optionValueForAddress(
                aShipping,
                isSelected,
                order,
                { className: 'multi-shipping' }
            );

            var newAddress = addressOption.html() === order.resources.addNewAddress;
            var matchingUUID = aShipping.UUID === shipping.UUID;
            if ((newAddress && matchingUUID) || (!newAddress && matchingUUID) || (!newAddress && !matchingUUID)) {
                $shippingAddressSelector.append(addressOption);
            }
            if (newAddress && !matchingUUID) {
                $(addressOption[0]).remove();
            }
        });
    }

    if (!hasSelectedAddress) {
        // show
        $(form).addClass('hide-details');
    } else {
        $(form).removeClass('hide-details');
    }

    $('body').trigger('shipping:updateShippingAddressSelector', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        customer: customer
    });
}

/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues(shipping) {
    var addressObject = $.extend({}, shipping.shippingAddress);
    var elem = $('.select-shipping-address-type.top')[0];
    var displayStyle = elem ? window.getComputedStyle(elem).display : '';

    if (displayStyle !== 'none') {
        return;
    }

    if (!addressObject) {
        addressObject = {
            firstName: null,
            lastName: null,
            address1: null,
            address2: null,
            city: null,
            postalCode: null,
            stateCode: null,
            countryCode: null,
            phone: null,
            countryCodePrefix: null
        };
    }

    addressObject.isGift = shipping.isGift;
    addressObject.giftMessage = shipping.giftMessage;

    $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
        var form = el.form;
        if (!form) return;
        var countryCode = addressObject.countryCode;

        if (addressObject.firstName !== null) {
            $('input[name$=_firstName]', form).val(addressObject.firstName);
        }
        if (addressObject.lastName !== null) {
            $('input[name$=_lastName]', form).val(addressObject.lastName);
        }
        if (addressObject.address1 !== null) {
            $('input[name$=_address1]', form).val(addressObject.address1);
        }
        if (addressObject.address2 !== null) {
            $('input[name$=_address2]', form).val(addressObject.address2);
        } else {
            $('input[name$=_address2]', form).val(''); // clear address2 field if address2 is null to avoid showing SubBuilding number twice
        }
        if (addressObject.city !== null) {
            $('input[name$=_city]', form).val(addressObject.city);
        }
        if (addressObject.postalCode !== null) {
            $('input[name$=_postalCode]', form).val(addressObject.postalCode);
        }
        if (addressObject.stateCode !== null) {
            $('select[name$=_stateCode],input[name$=_stateCode]', form).val(addressObject.stateCode);
        }

        if (countryCode && typeof countryCode === 'object') {
            $('select[name$=_country]', form).val(addressObject.countryCode.value);
        } else if ((addressObject.countryCode && $('[id^="shipping_newAddress"]').prop('checked'))
                    || !$('[id^="shipping_newAddress"]').prop('checked')) {
            $('select[name$=_country]', form).val(addressObject.countryCode);
        }

        $('select[name$=_countryCodeDropdownPrefix]', form).val(addressObject.countryCodePrefix || '');
        $('input[name$=_countryCodePrefix]', form).val(addressObject.countryCodePrefix || '');

        if ($('input[name$=_countryCodePrefix]', form).val() !== $('select[name$=_countryCodeDropdownPrefix]', form).val()) {
            $('select[name$=_countryCodeDropdownPrefix]', form).val('OTHER');
            $('.js_country-code-dropdown', form).addClass('d-none');
            $('.js_country-code-input', form).removeClass('d-none');
        } else {
            $('.js_country-code-dropdown', form).removeClass('d-none');
            $('.js_country-code-input', form).addClass('d-none');
        }

        if (addressObject.phone !== null) {
            $('input[name$=_phone]', form).val(addressObject.phone);
        }

        if ($('.gift-message:not(".show")').hasClass('collapse')) {
            $('input[name$=_isGift]', form).prop('checked', false);
        } else {
            $('input[name$=_isGift]', form).prop('checked', true);
        }
        if (!$('.suggested-address').length > 0) {
            $('textarea[name$=_giftMessage]', form).val(addressObject.isGift && addressObject.giftMessage ? addressObject.giftMessage : '');
        }
    });

    $('body').trigger('shipping:updateShippingAddressFormValues', { shipping: shipping });
}

/**
 * updates the shipping method radio buttons within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingMethods(shipping) {
    var uuidEl = $('input[value=' + shipping.UUID + ']');
    if (uuidEl && uuidEl.length > 0) {
        $.each(uuidEl, function (shipmentIndex, el) {
            var form = el.form || el.closest('fieldset.shipping-method-block');
            if (!form) return;

            var $shippingMethodList = $('.shipping-method-list', form);

            if ($shippingMethodList && $shippingMethodList.length) {
                var newList = '';
                var shippingMethods = shipping.applicableShippingMethods;
                var selected = shipping.selectedShippingMethod || {};
                var shippingMethodFormID = form.name + '_shippingAddress_shippingMethodID';
                //
                // Create the new rows for each shipping method
                //
                $.each(shippingMethods, function (methodIndex, shippingMethod) {
                    var tmpl = $('#shipping-method-template').clone();
                    $('input[name=shipmentUUID]', tmpl).prop('value', shipping.UUID);
                    // Calculate aria-label with delivery date
                    var fullAriaLabel = shippingMethod.ariaLabel || '';
                    var estArrivalText = '';

                    if (shippingMethod.estArrivalDate) {
                        if (typeof shippingMethod.estArrivalDate === 'object' &&
                            shippingMethod.estArrivalDate.single && shippingMethod.estArrivalDate.split) {
                            var isSplit = shipping.shipmentGroups && shipping.shipmentGroups.length > 1;
                            estArrivalText = isSplit ? shippingMethod.estArrivalDate.split : shippingMethod.estArrivalDate.single;
                        } else {
                            estArrivalText = shippingMethod.estArrivalDate;
                        }

                        if (estArrivalText && estArrivalText.trim() !== '') {
                            fullAriaLabel = fullAriaLabel + ' ' + estArrivalText;
                        }
                    }

                    // set input
                    $('input.custom-control-input', tmpl)
                        .prop('id', 'shippingMethod-' + shippingMethod.ID + '-' + shipping.UUID)
                        .prop('name', shippingMethodFormID)
                        .prop('value', shippingMethod.ID)
                        .attr('aria-label', fullAriaLabel)
                        .attr('checked', shippingMethod.ID === selected.ID);

                    $('label', tmpl)
                        .prop('for', 'shippingMethod-' + shippingMethod.ID + '-' + shipping.UUID);
                    // set shipping method name
                    $('.display-name', tmpl).text(shippingMethod.displayName);
                    // set or hide arrival time
                    if (shippingMethod.estimatedArrivalTime) {
                        $('.arrival-time', tmpl)
                            .text('Delivers within ' + shippingMethod.estimatedArrivalTime)
                            .show();
                    }
                    if (estArrivalText) {
                        $('.estimated-shipping-time', tmpl).text(estArrivalText);
                    }
                    // set shipping cost
                    if (shippingMethod.shippingCost == 0 || shippingMethod.shippingCost === 'Free') { // eslint-disable-line
                        $('.shipping-cost', tmpl).addClass('strike-through')
                            .html('<span class="sr-only">Old shipping cost: </span><s>' + shippingMethod.originalShippingCost + '</s>');
                        if (shippingMethod.originalShippingCostValue === 0) {
                            $('.shipping-cost', tmpl).addClass('d-none');
                        }
                        $('.shipping-free', tmpl).removeClass('d-none');
                    } else {
                        $('.shipping-cost', tmpl).text(shippingMethod.shippingCost).removeClass('d-none');
                    }
                    newList += tmpl.html();
                });

                var activeEl = document.activeElement;
                var isFocusInsideList = $shippingMethodList.has(activeEl).length > 0 || $(activeEl).is('#shipping-method-loading');

                $shippingMethodList.empty();
                $shippingMethodList.append(newList);

                var $all = $shippingMethodList.find('input[type="radio"]');
                var $target = $all.filter(':checked');
                if (!$target.length) {
                    $target = $all.first();
                }

                if (isFocusInsideList && $target.length && $target.is(':visible')) {
                    $target.focus();
                }
            }
        });
    }

    $('body').trigger('updateShippingMethods');

    $('body').trigger('shipping:updateShippingMethods', { shipping: shipping });
}

/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 */
function updateShippingMethodList($shippingForm) {
    // delay for autocomplete!
    clearTimeout(shippingListTimer);
    shippingListTimer = setTimeout(function () {
        var $shippingMethodList = $('.shipping-method-list');
        var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var url = $shippingMethodList.data('actionUrl');
        urlParams.shipmentUUID = shipmentUUID;
        urlParams.address1Info = $shippingForm.find('input[name$="shippingAddress_addressFields_address1"]').val();
        urlParams.address2Info = $shippingForm.find('input[name$="shippingAddress_addressFields_address2"]').val();
        var $countryCodePrefix = $shippingForm.find('input[name$="shippingAddress_addressFields_countryCodePrefix"]');
        if ($countryCodePrefix.length) {
            urlParams.countryCodePrefix = $countryCodePrefix.val().replace(/[^0-9]/g, '');
        }
        var loqateShippingAddress = $shippingForm.find('input[name$="LoqateShippingAddress"]').val();
        if (loqateShippingAddress) {
            urlParams.loqateShippingAddress = loqateShippingAddress;
        }

        $shippingMethodList.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer,
                            options: { keepOpen: true, skipAddressUpdate: true }
                        });

                    if (data.isPOBOX) {
                        $('.delay-shipping-disclaimer').removeClass('d-none');
                    } else {
                        $('.delay-shipping-disclaimer').addClass('d-none');
                    }

                    if (data.isRemovedPostalCode) {
                        var validationMsg = data.removedPostalError;
                        if (validationMsg) {
                            $('#shippingZipCodeDefault').addClass('is-invalid');
                            $('#ZipCodeDefault').show().html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMsg + '<span>');
                        } else {
                            $('#shippingZipCodeDefault').removeClass('is-invalid');
                            $('#ZipCodeDefault').empty().hide();
                        }
                    }

                    $('#isHawaiiAlaskaEligible').val(data.isHawaiiAlaskaEligible);

                    if ($('#isHazardousProducts').val() === 'true' && $('#isHawaiiAlaskaEligible').val() === 'true') {
                        if ($('#shipmentSelector-default option:selected').data('state-code') === '') {
                            $('#hazardousModal').modal('show');
                        }
                    }

                    $shippingMethodList.spinner().stop();
                }
            }
        });
    }, 300);
}

var isRegisteredUser = $('.data-checkout-stage').data('customer-type') === 'registered';

function toggleShippingSummaries(order) {
    var wrapper = $('.summary-wrapper');
    if (!wrapper.length) return;
    wrapper.attr('data-egiftcard-only', order.isEGiftCardOnly ? 'true' : 'false');
    wrapper.find('.shipping-summary, .shipping-options-summary').toggleClass('d-none', order.isEGiftCardOnly);
    wrapper.find('.card-header').toggleClass('d-none', order.isEGiftCardOnly);
    $('.address-selector-block').toggleClass('d-none', order.isEGiftCardOnly && !isRegisteredUser);
}

function toggleShippingSummaryTotals(order) {
    $('.shipping-total-cost').closest('.row').toggleClass('d-none', order.isEGiftCardOnly);
}

function toggleUseShippingAddressForBilling(order) {
    var $checkbox = $('#useShippingAddressForBilling');
    if (!$checkbox.length) return;
    $('.use-shipping-for-billing').toggleClass('d-none', !order.isEGiftCardOnly && !order.hasBilling);
    $('.use-shipping-for-billing-container').toggleClass('d-none', !order.isEGiftCardOnly && !order.hasBilling);
    $checkbox.prop('checked', !order.isEGiftCardOnly);
    $checkbox.closest('.custom-control')
        .toggleClass('d-none', order.isEGiftCardOnly);
    if (order.isEGiftCardOnly && !isRegisteredUser) $('.billing-address-block').removeClass('d-none');
}
/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation(shipping, order) {
    $('[data-shipment-summary=' + shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $shippingAddressLabel = $container.find('.shipping-addr-label');
        var $addressContainer = $container.find('.address-summary');
        var $shippingPhone = $container.find('.shipping-phone');
        var $methodTitle = $container.find('.shipping-method-title');
        var $methodArrivalTime = $container.find('.shipping-method-arrival-time');
        var $methodPrice = $container.find('.shipping-method-price');
        var $shippingSummaryLabel = $container.find('.shipping-method-label');
        var $summaryDetails = $container.find('.row.summary-details');
        var giftMessageSummary = $container.find('.gift-summary');
        var $shippingCountry = $container.find('.countryCode');
        var $shippingCity = $container.find('.city');
        var $stateCode = $container.find('.stateCode');
        var $postalCode = $container.find('.postalCode');
        var $address1 = $container.find('.address1');
        var $address2 = $container.find('.address2');
        var methodMsg = $container.find('.shipping-method-msg');

        var address = shipping.shippingAddress;
        var selectedShippingMethod = shipping.selectedShippingMethod;
        var isGift = shipping.isGift;

        addressHelpers.methods.populateAddressSummary($addressContainer, address);

        // PM-1943 Country code and Phone formatting changes
        var siteLocale = $('#currentLocale').val();
        if (siteLocale === 'en_GB' && address && address.phone && address.countryCodePrefix) {
            var $phoneFormat = '+' + address.countryCodePrefix + ' ' + address.phone;
            $shippingPhone.text($phoneFormat);
        } else if (siteLocale === 'en_US' && address && address.phone) {
            $shippingPhone.text(address.phone.substr(0, 9) + '-' + address.phone.substr(10));
        } else {
            $shippingPhone.empty();
        }

        if (address && address.city) {
            $shippingCity.text(address.city + ', ');
        } else {
            $shippingCity.empty();
        }

        if (address && address.countryCode && siteLocale === 'en_GB') {
            $shippingCountry.text(address.countryCode.value);
        } else {
            $shippingCountry.empty();
        }

        if (address && address.stateCode) {
            $stateCode.text(address.stateCode);
        }

        if (address && address.address1) {
            $address1.text(address.address1);
        }

        if (address && address.address2) {
            $address2.text(address.address2);
        }

        if (address && address.postalCode) {
            $postalCode.text(address.postalCode);
        }

        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText',
                { selectedShippingMethod: selectedShippingMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            $methodTitle.text(selectedShippingMethod.displayName);
            if (selectedShippingMethod.maxEstimatedArrivalTime && selectedShippingMethod.estArrivalDate) {
                $methodArrivalTime.text(
                    'Delivers in ' + selectedShippingMethod.maxEstimatedArrivalTime + ' business days'
                );
            } else if (selectedShippingMethod.estimatedArrivalTime) {
                $methodArrivalTime.text(
                    '( ' + selectedShippingMethod.estimatedArrivalTime + ' )'
                );
            } else {
                $methodArrivalTime.empty();
            }

            if (selectedShippingMethod.shippingMsg) {
                methodMsg.text(selectedShippingMethod.shippingMsg);
            }

            $methodPrice.text(selectedShippingMethod.shippingCost);
        }

        if (isGift) {
            giftMessageSummary.find('.gift-message-summary').text(shipping.giftMessage);
            giftMessageSummary.removeClass('d-none');
        } else {
            giftMessageSummary.addClass('d-none');
        }
    });
    toggleShippingSummaries(order);
    toggleUseShippingAddressForBilling(order);
    toggleShippingSummaryTotals(order);
    $('body').trigger('shipping:updateShippingSummaryInformation', { shipping: shipping, order: order });
}

function hideAddressSuggestionSection() {
    $('.suggested-address').removeClass('with-suggestion without-suggestion');
}

/**
 * Update the read-only portion of the shipment display (per PLI)
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updatePLIShippingSummaryInformation(productLineItem, shipping, order, options) {
    var $pli = $('input[value=' + productLineItem.UUID + ']');
    var form = $pli && $pli.length > 0 ? $pli[0].form : null;

    if (!form) return;

    var $viewBlock = $('.view-address-block', form);

    var address = shipping.shippingAddress || {};
    var selectedMethod = shipping.selectedShippingMethod;

    var nameLine = address.firstName ? address.firstName + ' ' : '';
    if (address.lastName) nameLine += address.lastName;

    var address1Line = address.address1;
    var address2Line = address.address2;

    var phoneLine;
    if (address.countryCodePrefix) {
        phoneLine = address.countryCodePrefix + ' ' + address.phone;
    } else {
        phoneLine = address.phone;
    }

    var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
    var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
    var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
        ? 'Delivers within ' + selectedMethod.estimatedArrivalTime
        : '';

    var tmpl = $('#pli-shipping-summary-template').clone();

    $('.ship-to-name', tmpl).text(nameLine);
    $('.ship-to-address1', tmpl).text(address1Line);
    $('.ship-to-address2', tmpl).text(address2Line);
    $('.ship-to-city', tmpl).text(address.city);
    if (address.stateCode) {
        $('.ship-to-st', tmpl).text(address.stateCode);
    }
    $('.ship-to-zip', tmpl).text(address.postalCode);
    $('.ship-to-phone', tmpl).text(phoneLine);

    if (!address2Line) {
        $('.ship-to-address2', tmpl).hide();
    }

    if (!phoneLine) {
        $('.ship-to-phone', tmpl).hide();
    }

    if (shipping.selectedShippingMethod) {
        $('.display-name', tmpl).text(methodNameLine);
        $('.arrival-time', tmpl).text(methodArrivalTime);
        $('.price', tmpl).text(shippingCost);
    }

    if (shipping.isGift) {
        $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        var shipment = $('.gift-message-' + shipping.UUID);
        $(shipment).val(shipping.giftMessage);
    } else {
        $('.gift-summary', tmpl).addClass('d-none');
    }
    // checking h5 title shipping to or pickup
    var $shippingAddressLabel = $('.shipping-header-text', tmpl);
    $('body').trigger('shipping:updateAddressLabelText',
        { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

    $viewBlock.html(tmpl.html());

    $('body').trigger('shipping:updatePLIShippingSummaryInformation', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        options: options
    });
}

/**
 * Update the hidden form values that associate shipping info with product line items
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateProductLineItemShipmentUUIDs(productLineItem, shipping) {
    $('input[value=' + productLineItem.UUID + ']').each(function (key, pli) {
        var form = pli.form;
        $('[name=shipmentUUID]', form).val(shipping.UUID);
        $('[name=originalShipmentUUID]', form).val(shipping.UUID);

        $(form).closest('.card').attr('data-shipment-uuid', shipping.UUID);
    });

    $('body').trigger('shipping:updateProductLineItemShipmentUUIDs', {
        productLineItem: productLineItem,
        shipping: shipping
    });
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation(shipping, order, customer, options) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach(function (aShipping) {
        aShipping.productLineItems.items.forEach(function (productLineItem) {
            updateProductLineItemShipmentUUIDs(productLineItem, aShipping);
        });
    });

    // Now update shipping information, based on those associations
    updateShippingMethods(shipping);

    if (shipping.shippingAddress) {
        updateShippingAddressFormValues(shipping);
    }

    updateShippingSummaryInformation(shipping, order);
    if (shipping.shippingAddress) {
        $('.checkout-tax-msg').text(order.resources.taxMsg);
        $('.checkout-total-msg').text(order.resources.totalMsg);
    }
    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach(function (productLineItem) {
        updateShippingAddressSelector(productLineItem, shipping, order, customer);
        updatePLIShippingSummaryInformation(productLineItem, shipping, order, options);
    });
    if (!order.hasGiftWrap && !order.hasGiftMessage) {
        $('.edit-gift-options-button').addClass('d-none');
    } else {
        $('.edit-gift-options-button').removeClass('d-none');
    }

    $('body').trigger('shipping:updateShippingInformation', {
        order: order,
        shipping: shipping,
        customer: customer,
        options: options
    });
}

/**
 * Update the checkout state (single vs. multi-ship)
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateMultiShipInformation(order) {
    var $checkoutMain = $('#checkout-main');
    var $checkbox = $('[name=usingMultiShipping]');
    var $submitShippingBtn = $('button.submit-shipping');
    $('.shipping-error .alert-danger').remove();

    if (order.usingMultiShipping) {
        $checkoutMain.addClass('multi-ship');
        $checkbox.prop('checked', true);
    } else {
        $checkoutMain.removeClass('multi-ship');
        $checkbox.prop('checked', null);
        $submitShippingBtn.prop('disabled', null);
    }

    $('body').trigger('shipping:updateMultiShipInformation', { order: order });
}

/**
  * Create an alert to display the error message
  * @param {Object} message - Error message to display
  */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
    'fade show" role="alert">' +
    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
    '<span aria-hidden="true">&times;</span>' +
    '</button>' + message + '</div>';

    $('.shipping-error').append(errorHtml);
    scrollAnimate($('.shipping-error'));
}

/**
 * fills shipping address form
 * @param {Object} formData - new data to fill the address form with
 * @param {boolean} excludeCountry - if true, country field will not be updated
 */
function fillShippingForm(formData, excludeCountry) {
    var $form = $('.shipping-form');
    if ($form.length < 1) return;
    $form.spinner().start();
    $('input[name$=address1]', $form).val(formData.address1);
    $('input[name$=address2]', $form).val(formData.address2);
    $('input[name$=city]', $form).val(formData.city);
    $('input[name$=postalCode]', $form).val(formData.postalCode);
    $('select[name$=stateCode],input[name$=_stateCode]', $form).val(formData.stateCode);
    if (!excludeCountry) {
        $('select[name$=_country]', $form).val(formData.countryCode);
    }
    $form.spinner().stop();
}

/**
 * fills the rest of shipping address form
 * @param {Object} formData - new data to fill the address form with
 * @param {boolean} includeCountry - if true, country field will be updated and triggered change event
 */
function fillOtherShippingFormFields(formData, includeCountry) {
    var $form = $('.shipping-form');
    if ($form.length < 1) return;
    $form.spinner().start();
    $('input[name$=firstName]', $form).val(formData.firstName);
    $('input[name$=lastName]', $form).val(formData.lastName);
    $('input[name$=phone]', $form).val(formData.phone);
    setTimeout(function () {
        if (formData.countryCode && includeCountry) {
            $('select[name$=country]', $form).val(formData.countryCode).trigger('change');
        }
    }, 100);

    $form.spinner().stop();
}

/**
 * renders suggested address container if validated address is different than original
 *  @param {Object} original - Original entered address
 *  @param {Object} suggested - Validated address from avatax
 *  @param {Object} modifications - Object containing the modifications for suggessed address modal
 *  @return {boolean} true if the suggestion is different than original and rendered, false if they are the same and suggestion is not rendered
 */
function prepareSuggestedAddress(original, suggested, modifications) {
    var $container = $('.suggested-address');
    var stateAndPostalCodeMatchError = modifications && modifications.stateAndPostalCodeMatchError;

    $('.suggested-address-block .use-address-link').data('address', suggested);
    $('.suggested-address-block .suggested-full-address').html(
        (suggested.address1 ? ('<span data-cs-mask>' + suggested.address1 + '</span>') : '')
        + (suggested.address2 ? (' <span data-cs-mask>' + suggested.address2 + '</span>') : '') + ', '
        + (suggested.city ? ('<span data-cs-mask>' + suggested.city + '</span>') : '') + ', '
        + (suggested.stateCode ? ('<span data-cs-mask>' + suggested.stateCode + '</span>') : '') + ' '
        + (suggested.postalCode ? ('<span data-cs-mask>' + suggested.postalCode + '</span>') : '')
        + (suggested.countryName && stateAndPostalCodeMatchError ? (', <span data-cs-mask>' + suggested.countryName + '</span>') : '')
    );

    $('.original-address-block .use-address-link').data('address', original);
    $('.original-address-block .suggested-full-address').html(
        (original.address1 ? ('<span data-cs-mask>' + original.address1 + '</span>') : '')
        + (original.address2 ? (' <span data-cs-mask>' + original.address2 + '</span>') : '') + ', '
        + (original.city ? ('<span data-cs-mask>' + original.city + '</span>') : '') + ', '
        + (original.stateCode ? ('<span data-cs-mask>' + original.stateCode + '</span>') : '') + ' '
        + (original.postalCode ? ('<span data-cs-mask>' + original.postalCode + '</span>') : '')
        + (original.countryName && stateAndPostalCodeMatchError ? (', <span data-cs-mask>' + original.countryName + '</span>') : '')
    );

    // Since matchScore on backend was set to 100 instead of 95, we need to compare the original and suggested addresses
    // to determine if they are the same or not. If they are exactly the same, we will not show the suggestion message.
    if ($('.original-address-block .suggested-full-address').text() === $('.suggested-address-block .suggested-full-address').text()) {
        hideAddressSuggestionSection();
        $('.submit-shipping').removeClass('d-none');
        return false;
    }

    $container.addClass('with-suggestion');
    $('.submit-shipping').addClass('d-none');

    var addressButtons = $container.find('.js_addresses-btns');
    var addressTittle = $container.find('.suggested-address-attention');
    if (stateAndPostalCodeMatchError) {
        addressTittle.find('.confirm-title').text(addressTittle.data('country-title'));
        addressButtons.find('.js-correct').addClass('d-none');
        addressButtons.find('.js-suggested').addClass('d-none');
        addressButtons.find('.js-manual').removeClass('d-none');
        addressButtons.find('.js-confirm').removeClass('d-none');

        addressButtons.find('.js-manual').off('click').on('click', function () {
            $('#shipping_newAddress0').prop('checked', true).trigger('change');
            $('.toogle-addr-search').trigger('click');
            var originalAddress = Object.assign({}, original);
            originalAddress.countryCode = '';

            fillShippingForm(originalAddress, true);
            fillOtherShippingFormFields(originalAddress, true);
        });

        addressButtons.find('.js-confirm').off('click').on('click', function () {
            $('#shipping_newAddress0').prop('checked', true).trigger('change');
            $('.toogle-addr-search').trigger('click');
            fillShippingForm(suggested, true);
            fillOtherShippingFormFields(suggested, true);
        });
    } else {
        addressTittle.find('.confirm-title').text(addressTittle.data('address-title'));
        addressButtons.find('.js-correct').removeClass('d-none');
        addressButtons.find('.js-suggested').removeClass('d-none');
        addressButtons.find('.js-manual').addClass('d-none');
        addressButtons.find('.js-confirm').addClass('d-none');
    }

    // Move focus to the validation message for screen reader announcement
    setTimeout(function () {
        var $wrapper = $('.address-confirmation-wrapper');
        if ($wrapper.length) {
            // Make it focusable temporarily
            $wrapper.attr('tabindex', '-1');
            $wrapper.focus();
            // Remove tabindex after announcement to avoid unnecessary tab stop
            $wrapper.one('blur', function () {
                $(this).removeAttr('tabindex');
            });
        }
    }, 100);

    return true;
}

/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */
function shippingFormResponse(defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';

    $('.suggested-address-block .use-address-link').click(function (e) {
        e.preventDefault();
        var suggestedAddress = $(this).data('address');
        fillShippingForm(suggestedAddress);
        $('.shipping-form .form-control.is-invalid').removeClass('is-invalid');
        $('.shipping-form .invalid-feedback').hide();
        hideAddressSuggestionSection();
        $('input[name="ignoreAddressValidation"]').val('yes');
        if ($('#LoqateCommercialShippingAddress').length > 0 && suggestedAddress.commercial) $('#LoqateCommercialShippingAddress').val(suggestedAddress.address1 + suggestedAddress.address2 + suggestedAddress.city + suggestedAddress.stateCode + suggestedAddress.postalCode);
        if ($('#LoqatePOBoxShippingAddress').length > 0 && suggestedAddress.poBox) $('#LoqatePOBoxShippingAddress').val(suggestedAddress.address1 + suggestedAddress.address2 + suggestedAddress.city + suggestedAddress.stateCode + suggestedAddress.postalCode);
        if ($('#LoqateShippingAddress').length > 0) $('#LoqateShippingAddress').val(suggestedAddress.address1 + suggestedAddress.address2 + suggestedAddress.city + suggestedAddress.stateCode + suggestedAddress.postalCode);

        if ($('#shipmentSelector-default option:selected').length > 0 && $('#shipmentSelector-default option:selected').data('address-id')) {
            $('input[name="originalAddressId"]').val($('#shipmentSelector-default option:selected').data('address-id'));
        }
        $('button.submit-shipping').removeClass('d-none').trigger('click');
    });

    $('.original-address-block .use-address-link').click(function (e) {
        e.preventDefault();
        fillShippingForm($(this).data('address'));
        hideAddressSuggestionSection();
        $('input[name="ignoreAddressValidation"]').val('yes');
        $('button.submit-shipping').removeClass('d-none').trigger('click');
    });

    var showSuggesedAddress = data.suggestedAddress && prepareSuggestedAddress(data.address, data.suggestedAddress, { isSavedAddress: data.isSavedAddress, stateAndPostalCodeMatch: data.stateAndPostalCodeMatchError });
    if (showSuggesedAddress) {
        defer.reject(data);
    } else {
        hideAddressSuggestionSection();
        $('.submit-shipping').removeClass('d-none');
    }

    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            $('.shipping-address-block').addClass('customer-validation-error');
            $('.shipping-address-block').find('input').each(function () {
                if ($(this).hasClass('validatePrefixField')) {
                    $(this).siblings('.message-desc:visible').addClass('d-none');
                }
                var $label = $('.form-control-label').filter('[for="' + this.getAttribute('id') + '"]');
                if ($(this).val()) {
                    $label.addClass('form-control-label--float-up');
                }
            });
            data.fieldErrors.forEach(function (error) {
                if (Object.keys(error).length) {
                    formHelpers.loadFormErrors(formSelector, error);
                }
            });
        }
        if (data.skipAddressValidation && data.address) {
            var original = data.address;
            $('.original-address-block .use-address-link').data('address', original);
            $('.original-address-block .suggested-full-address').html(
                (original.address1 ? ('<span data-cs-mask>' + original.address1 + '</span>') : '')
                + (original.address2 ? (' <span data-cs-mask>' + original.address2 + '</span>') : '') + ', '
                + (original.city ? ('<span data-cs-mask>' + original.city + '</span>') : '') + ', '
                + (original.stateCode ? ('<span data-cs-mask>' + original.stateCode + '</span>') : '') + ' '
                + (original.postalCode ? ('<span data-cs-mask>' + original.postalCode + '</span>') : '')
            );
            $('.suggested-address').addClass('without-suggestion');
            $('.submit-shipping').addClass('d-none');

            // Move focus to the validation message for screen reader announcement
            setTimeout(function () {
                var $wrapper = $('.address-confirmation-wrapper');
                if ($wrapper.length) {
                    // Make it focusable temporarily
                    $wrapper.attr('tabindex', '-1');
                    $wrapper.focus();
                    // Remove tabindex after announcement to avoid unnecessary tab stop
                    $wrapper.one('blur', function () {
                        $(this).removeAttr('tabindex');
                    });
                }
            }, 100);
        }

        if (data.serverErrors && data.serverErrors.length) {
            $.each(data.serverErrors, function (index, element) {
                createErrorNotification(element);
            });
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
        }
        defer.reject(data);
    } else if (!data.suggestedAddress || !showSuggesedAddress) {
        // Populate the Address Summary
        $('.shipping-address-block').removeClass('customer-validation-error');
        $('body').trigger('checkout:updateCheckoutView', {
            order: data.order,
            customer: data.customer
        });
        scrollAnimate($('.payment-form'));
        defer.resolve(data);
    } else {
        $('.shipping-address-block').removeClass('customer-validation-error');
        scrollAnimate($('.shipping-address'));
        defer.resolve(data);
    }
}
/**
 * Clear out all the shipping form values and select the new address in the drop down
 * @param {Object} order - the order object
 */
function clearShippingForms(order) {
    order.shipping.forEach(function (shipping) {
        $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
            var form = el.form;
            if (!form) return;

            $('input[name$=_firstName]', form).val('');
            $('input[name$=_lastName]', form).val('');
            $('input[name$=_address1]', form).val('');
            $('input[name$=_address2]', form).val('');
            $('input[name$=_city]', form).val('');
            $('input[name$=_postalCode]', form).val('');
            $('select[name$=_stateCode],input[name$=_stateCode]', form).val('');
            $('select[name$=_country]', form).val('');

            $('input[name$=_phone]', form).val('');
            $('select[name$=_countryCodeDropdownPrefix]', form).val('');
            $('input[name$=_countryCodePrefix]', form).val('');

            $('input[name$=_isGift]', form).prop('checked', false);
            $('textarea[name$=_giftMessage]', form).val('');
            $(form).find('.gift-message').addClass('collapse');

            $(form).attr('data-address-mode', 'new');
            var addressSelectorDropDown = $('.addressSelector option[value=new]', form);
            $(addressSelectorDropDown).prop('selected', true);
        });
    });

    $('body').trigger('shipping:clearShippingForms', { order: order });
}

/**
 * Does Ajax call to create a server-side shipment w/ pliUUID & URL
 * @param {string} url - string representation of endpoint URL
 * @param {Object} shipmentData - product line item UUID
 * @returns {Object} - promise value for async call
 */
function createNewShipment(url, shipmentData) {
    $.spinner().start();
    return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: shipmentData
    });
}

/**
 * Does Ajax call to select shipping method
 * @param {string} url - string representation of endpoint URL
 * @param {Object} urlParams - url params
 * @param {Object} el - element that triggered this call
 */
function selectShippingMethodAjax(url, urlParams, el) {
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams
    })
        .done(function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer,
                        options: { keepOpen: true },
                        urlParams: urlParams
                    }
                );
                $('body').trigger('checkout:postUpdateCheckoutView',
                    {
                        el: el
                    }
                );
            }
            $('body').trigger('giftcard:clear');
            $.spinner().stop();
        })
        .fail(function () {
            $.spinner().stop();
        });
}

/**
 * Hide and show to appropriate elements to show the multi ship shipment cards in the enter view
 * @param {jQuery} element - The shipping content
 */
function enterMultishipView(element) {
    element.find('.btn-enter-multi-ship').removeClass('d-none');

    element.find('.view-address-block').addClass('d-none');
    element.find('.shipping-address').addClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').addClass('d-none');
    element.find('.btn-edit-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
}

/**
 * Hide and show to appropriate elements to show the multi ship shipment cards in the view mode
 * @param {jQuery} element - The shipping content
 */
function viewMultishipAddress(element) {
    element.find('.view-address-block').removeClass('d-none');
    element.find('.btn-edit-multi-ship').removeClass('d-none');

    element.find('.shipping-address').addClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').addClass('d-none');
    element.find('.btn-enter-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');
}

/**
 * Hide and show to appropriate elements that allows the user to edit multi ship address information
 * @param {jQuery} element - The shipping content
 */
function editMultiShipAddress(element) {
    // Show
    element.find('.shipping-address').removeClass('d-none');
    element.find('.btn-save-multi-ship.save-shipment').removeClass('d-none');

    // Hide
    element.find('.view-address-block').addClass('d-none');
    element.find('.btn-enter-multi-ship').addClass('d-none');
    element.find('.btn-edit-multi-ship').addClass('d-none');
    element.find('.multi-ship-address-actions').addClass('d-none');

    $('body').trigger('shipping:editMultiShipAddress', { element: element, form: element.find('.shipping-form') });
}

/**
 * perform the proper actions once a user has clicked enter address or edit address for a shipment
 * @param {jQuery} element - The shipping content
 * @param {string} mode - the address mode
 */
function editOrEnterMultiShipInfo(element, mode) {
    var form = $(element).closest('form');
    var root = $(element).closest('.shipping-content');

    $('body').trigger('shipping:updateDataAddressMode', { form: form, mode: mode });

    editMultiShipAddress(root);

    var addressInfo = addressHelpers.methods.getAddressFieldsFromUI(form);

    var savedState = {
        UUID: $('input[name=shipmentUUID]', form).val(),
        shippingAddress: addressInfo
    };

    root.data('saved-state', JSON.stringify(savedState));
}

/**
 * updates the giftwrap section based on selected and available giftwrap products
 * @param {Object} response - response from call to add/remove giftwrap product
 */
function updateGiftWrapSection(response) {
    if (response.order.giftWrapProductData) {
        Object.keys(response.order.giftWrapProductData).forEach(function (giftWrapProductID) {
            var giftWrapEligibleWrapperSelectorString = '.gift-wrap-eligible-wrapper[data-gift-wrap-id="' + giftWrapProductID + '"';
            var giftWrapData = response.order.giftWrapProductData[giftWrapProductID];

            $(giftWrapEligibleWrapperSelectorString).each(function () {
                var hasGiftWrap = $(this).find('input.gift-wrap:checked').length > 0;
                if (!hasGiftWrap && giftWrapData.totalInBasket >= giftWrapData.ATS) {
                    $(this).find('.gift-wrap-eligible').addClass('d-none');
                    $(this).find('.gift-wrap-not-available').removeClass('d-none');
                } else {
                    $(this).find('.gift-wrap-eligible').removeClass('d-none');
                    $(this).find('.gift-wrap-not-available').addClass('d-none');
                }
            });
        });
    }
}

function disableAutofill() {
    if (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)) {
        $('.js_type-address').prop('autocomplete', 'one-time-password');
    }
}

function handleGlobaleCountry(countryValue) {
    if (countryValue) {
        var globaleCountry = getGlobaleCountry(countryValue);
        var disableInputSelector = '.shippingFirstName, .shippingLastName, .shippingAddressOne, .shippingcountryCodeDropdownPrefix, .shippingPhoneNumber, .shippingAddressTwo, .shippingAddressCity, .shippingZipCode';
        var disableShippingInputs = false;
        var disableSaveShippingInputs = false;
        if (globaleCountry) {
            var geCountry = globaleCountry.countryCode;
            var geCurrency = globaleCountry.currencyCode;
            var geCountryName = globaleCountry.name;

            var $cartRedirectAnchor = $('.globale-country-modal-redirect-link');
            if ($cartRedirectAnchor && $cartRedirectAnchor.length > 0) {
                var cartRedirectUrl = new URL($cartRedirectAnchor.attr('href'));
                cartRedirectUrl.searchParams.set('geCountryCode', geCountry);
                cartRedirectUrl.searchParams.set('geCurrencyCode', geCurrency);
                $cartRedirectAnchor.attr('href', cartRedirectUrl);
                $cartRedirectAnchor.data('country-code', geCountry);
                $cartRedirectAnchor.data('currency-code', geCurrency);
            }

            $('.globale-country-modal-country-name').text(geCountryName);

            var isEditSavedAddressModalOpen = $('.modal.edit-saved-address').hasClass('show');
            if (!isEditSavedAddressModalOpen) {
                $('#globaleCountryModal').modal('show');
            }

            $('.shippingCountry').addClass('ge-country');
            var addressMode = $('#dwfrm_shipping').attr('data-address-mode') ? $('#dwfrm_shipping').attr('data-address-mode') : 'new';
            if (addressMode === 'new') disableShippingInputs = true;
            disableSaveShippingInputs = true;
        } else {
            $('.shippingCountry').removeClass('ge-country');
        }
        $('#dwfrm_shipping').find(disableInputSelector).prop('disabled', disableShippingInputs);
        $('form.save-address').find(disableInputSelector).prop('disabled', disableSaveShippingInputs);
        addressHelpers.methods.manageSubmitShippingBtn();
    }
}

function initializeShipping() {
    $('.gift-message-btn').on('click', function () {
        if (!($(this).parents().find('.gift-message').hasClass('show'))) {
            $('input[name$=_isGift]').prop('checked', true);
            $('#giftMessage').focus();
            $('.gift-message-btn').find('.icon').removeClass('plus-blue').addClass('minus-blue');
        } else {
            $('input[name$=_isGift]').prop('checked', false);
            $('#giftMessage').val('');
            $('.gift-message-btn').find('.icon').removeClass('minus-blue').addClass('plus-blue');
        }
    });
    $('.gift-message.collapse').on('show.bs.collapse', function () {
        $('.gift-message-btn').find('.icon').removeClass('plus-blue').addClass('minus-blue');
    }).on('hide.bs.collapse', function () {
        $('.gift-message-btn').find('.icon').removeClass('minus-blue').addClass('plus-blue');
    });

    $('#giftMessage').on('input', function () {
        var targetedSelector = $(this).parent().find('.remaining-characters-value');
        var currentMessageLength = $(this).val().length;
        var remainingCharacters = 200 - currentMessageLength;
        targetedSelector.text(remainingCharacters);

        if (remainingCharacters === 0) {
            $('#giftMessage').addClass('full');
        } else if (remainingCharacters > 0 && $('#giftMessage').hasClass('full')) {
            $('#giftMessage').removeClass('full');
        }
    });

    $('.gift').on('change', function () {
        var targetedSelector = $('.remaining-characters-value');
        var currentMessageLength = $('#giftMessage').val().length;
        var remainingCharacters = 200 - currentMessageLength;
        targetedSelector.text(remainingCharacters);

        if (remainingCharacters === 0) {
            $('#giftMessage').addClass('full');
        } else if (remainingCharacters > 0 && $('#giftMessage').hasClass('full')) {
            $('#giftMessage').removeClass('full');
        }
    });

    $('.shippingAddressOne, .shippingAddressTwo, .shippingAddressCity, .shippingState, .shippingZipCode', '#dwfrm_shipping').change(function () {
        $('input[name="ignoreAddressValidation"]').val('no');
    });

    $('.shippingAddressOne, .shippingAddressTwo, .shippingAddressCity, .shippingState, .shippingZipCode', '#dwfrm_shipping').on('input', function () {
        hideAddressSuggestionSection();
        $('.submit-shipping').removeClass('d-none');
    });

    $('.shippingcountryCodePrefix').on('blur', function () {
        var customMsg = $(this).data('custom-msg');
        $('#defaultcountryCodePrefix span').text(customMsg);
        $('.message-desc').addClass('d-none');
    });

    $(document).ready(function () {
        if ($('.shippingcountryCodePrefix').hasClass('is-invalid') || $('.shippingcountryCodePrefix').val() !== '') {
            $('.message-desc').addClass('d-none');
        } else {
            $('.message-desc').removeClass('d-none');
        }

        if ($('#isHazardousProducts').val() === 'true' && $('#isHawaiiAlaskaEligible').val() === 'true') {
            if ($('#modifyShippingAddress').val() === 'true') {
                $('.modify-ship-address').trigger('click');
            } else {
                $('#hazardousModal').modal('show');
            }
        }
    });

    $('.adreessShippingUsed').on('change', function () {
        const shippingData = $(this).find('option:selected').data();
        var url = $(this).attr('data-action-url');

        var $shippingMethodList = $('.shipping-form').find('.shipping-method-list');
        $shippingMethodList.spinner().start();
        if ($('.shippingcountryCodePrefix').hasClass('is-invalid')) {
            $('.message-desc').addClass('d-none');
        } else {
            $('.message-desc').removeClass('d-none');
        }
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: shippingData,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer,
                            options: { keepOpen: true }
                        });

                    if (data.isPOBOX) {
                        $('.delay-shipping-disclaimer').removeClass('d-none');
                    } else {
                        $('.delay-shipping-disclaimer').addClass('d-none');
                    }
                    $shippingMethodList.spinner().stop();
                }
            }
        });
    });

    $('.modify-ship-address').on('click', function (e) {
        e.preventDefault();
        $('#hazardousModal').modal('hide');
        $('input[name$=shippingAddress_addressFields_address1]').val('');
        $('input[name$=shippingAddress_addressFields_address2]').val('');
        $('input[name$=shippingAddress_addressFields_city]').val('');
        $('input[name$=shippingAddress_addressFields_postalCode]').val('');
        $('select[name$=shippingAddress_addressFields_states_stateCode]').val('');
        floatingLabel.refreshFloatingLabels();
        if ($('.data-checkout-stage').data('customer-type') === 'registered') {
            var userFirstName = $('#shipmentSelector-default option:selected').data('first-name') || $('.shipping-address-block .shippingFirstName').val();
            var userLastName = $('#shipmentSelector-default option:selected').data('last-name') || $('.shipping-address-block .shippingLastName').val();
            var userEmail = $('#shipmentSelector-default option:selected').data('email') || $('.shipping-address-block .shippingEmail').val();
            var userPhone = $('#shipmentSelector-default option:selected').data('phone') || $('.shipping-address-block .shippingPhoneNumber').val();

            $('[id^="shipping_newAddress"]').trigger('click');

            $('input[name$=shippingAddress_addressFields_firstName]').val(userFirstName);
            $('input[name$=shippingAddress_addressFields_lastName]').val(userLastName);
            $('input[name$=shippingAddress_addressFields_email]').val(userEmail);
            $('input[name$=shippingAddress_addressFields_phone]').val(userPhone);
        }

        if ($('#checkout-main').data('checkout-stage') === 'payment') {
            $('.shipping-summary .edit-button').trigger('click');
        }

        var emptyAreas = $('.shipping-address-block input.form-control').filter(function (index, element) {
            return $.trim($(element).val()) === '';
        });

        emptyAreas.first().trigger('focus');
    });

    $(function () {
        if ($('#checkout-main').attr('data-checkout-stage') === 'shipping') {
            var countryID = $('.shippingCountry').attr('data-id');
            $('.shippingCountry').attr('id', countryID);
            if ($('.shippingAddressOne').val() === '' && !$('#shippingCountryDefault').val()) {
                $('.shippingCountry').prop('selectedIndex', 0);
                $('.shipping-country-label').removeClass('form-control-label--float-up');
            } else {
                $('.shipping-country-label').addClass('form-control-label--float-up');
            }
            if ($('#shippingCountryDefault option[selected]').length === 0) {
                $('#shippingCountryDefault').val('');
                $('.shipping-country-label').removeClass('form-control-label--float-up');
            }
            $('.shippingCountry').on('focus', function () { $(this).closest('.form-group').find('label').addClass('form-control-label--float-up'); });
            $('.shippingCountry').on('change blur', function () {
                if ($(this).val() !== '') {
                    $(this).closest('.form-group').find('label').addClass('form-control-label--float-up');
                } else {
                    $(this).closest('.form-group').find('label').removeClass('form-control-label--float-up');
                }
            });
        }
    });

    disableAutofill();

    $(window).on('load', function () {
        var countryCode = $('.shippingCountry').val();
        if (getGlobaleCountry(countryCode)) {
            $('.shippingCountry').trigger('change');
        }
    });

    // PMG-998
    function formLabelsAriaHelper(labelledbyValue, isMultipleTab) {
        var shippingNewAddress = document.querySelectorAll('[aria-labelledby="' + labelledbyValue + '"]');
        for (var i = 0; i < shippingNewAddress.length; i++) {
            var element = shippingNewAddress[i];
            var newPropertyValue = labelledbyValue + i;
            element.setAttribute('aria-labelledby', newPropertyValue);
            var idAttr = element.getAttribute('id');
            var nameAttr = element.getAttribute('name');

            var parentDiv = element.parentNode;
            var labelInput = parentDiv.querySelector('[for="' + nameAttr + '"]');

            var currentID = element.getAttribute('id');
            if (currentID && document.querySelectorAll('#' + CSS.escape(currentID)).length > 1 && !isMultipleTab) {
                element.setAttribute('id', currentID + i);
                if (!labelInput) {
                    var newLabelInput = parentDiv.querySelector('[for="' + idAttr + '"]');
                    newLabelInput.setAttribute('for', element.getAttribute('id'));
                }
            }

            if (labelInput) {
                labelInput.setAttribute('id', newPropertyValue);

                if (isMultipleTab) {
                    element.setAttribute('name', nameAttr + i);
                    labelInput.setAttribute('for', nameAttr + i);

                    var idValue = element.getAttribute('id');
                    var dataParentValue = element.getAttribute('data-parent');

                    element.setAttribute('id', idValue + i);
                    element.setAttribute('data-parent', dataParentValue + i);

                    labelInput.setAttribute('data-parent', dataParentValue + i);
                    var hrefValue = labelInput.getAttribute('href');
                    labelInput.setAttribute('href', hrefValue + i);

                    var parentId = parentDiv.getAttribute('id');
                    parentDiv.setAttribute('id', parentId + i);
                }
            }
        }
    }

    $(document).ready(function () {
        // pm-uk PMG-998
        formLabelsAriaHelper('shipping_newAddressLabel', false);
        formLabelsAriaHelper('makeDefaultAddressLabel', false);
        formLabelsAriaHelper('shippingMethodRadioButtonLabel', false);
        // gf-uk PMG-998
        formLabelsAriaHelper('makeDefaultAddressLabel', false);
        // gf-us PMG-998
        formLabelsAriaHelper('promoCodeTab', true);

        // addresses-btns
        $('.js_addresses-btns button').on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            var parent = $this.closest('.suggested-address');
            if ($this.hasClass('js-suggested')) {
                parent.find('.suggested-address-block a').trigger('click');
            } else {
                parent.find('.original-address-block a').trigger('click');
            }
        });
    });
}

function isValidGiftMessage() {
    /* commented this code per PM-1512 : Allow customers to use special characters in gift message field */
    var $giftMessage = $('#giftMessage');

    if (!$giftMessage.length) {
        return true;
    }

    $('.invalid-feedback-gift-message, .invalid-feedback-gift-message-linebreaks').addClass('d-none');

    var giftMessageValue = $giftMessage.val().trim();

    if (!giftMessageValue.length) {
        return true;
    }

    var oldRegex;
    var giftMessageRegex;
    var pattern = $giftMessage.attr('pattern');
    var patternExclude = $giftMessage.data('pattern-exclude');
    var lineBreakRegex = new RegExp('\\r\\n|\\n|\\r');
    // eslint-disable-next-line no-useless-escape
    var emojiRegex = new RegExp(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/);

    if (patternExclude) {
        giftMessageRegex = new RegExp(patternExclude);
    }

    if (pattern) {
        oldRegex = new RegExp(pattern);
    }

    if (giftMessageRegex) {
        if (giftMessageRegex.test(giftMessageValue)) {
            $('.invalid-feedback-gift-message').removeClass('d-none');
            return false;
        }
    } else if (oldRegex && !oldRegex.test(giftMessageValue)) {
        $('.invalid-feedback-gift-message').removeClass('d-none');
        return false;
    }

    if (emojiRegex.test(giftMessageValue)) {
        $('.invalid-feedback-gift-message').removeClass('d-none');
        return false;
    }

    if (lineBreakRegex.test(giftMessageValue)) {
        $('.invalid-feedback-gift-message-linebreaks').removeClass('d-none');
        return false;
    }

    return true;
}

function handleLoqateAddress(form) {
    var handleLoqateCommercialAddress = $('#isShippingAddressLoqateCommercial').length > 0 && $('#LoqateCommercialShippingAddress').length > 0;
    var handleLoqatePOBox = $('#isShippingAddressLoqatePOBox').length > 0 && $('#LoqatePOBoxShippingAddress').length > 0;
    var handleLoqateShippingAddress = $('#isShippingAddressLoqate').length > 0 && $('#LoqateShippingAddress').length > 0;

    if (form && (handleLoqateCommercialAddress || handleLoqatePOBox || handleLoqateShippingAddress)) {
        var loqateCommercialShippingAddress = null;
        var loqatePOBoxShippingAddress = null;
        var loqateShippingAddress = null;
        if (handleLoqateCommercialAddress) {
            $('#isShippingAddressLoqateCommercial').val(false);
            loqateCommercialShippingAddress = $('#LoqateCommercialShippingAddress').val();
        }
        if (handleLoqatePOBox) {
            $('#isShippingAddressLoqatePOBox').val(false);
            loqatePOBoxShippingAddress = $('#LoqatePOBoxShippingAddress').val();
        }
        if (handleLoqateShippingAddress) {
            $('#isShippingAddressLoqate').val(false);
            loqateShippingAddress = $('#LoqateShippingAddress').val();
        }

        var loqateShippingAddressCheck = form.find('.shippingAddressOne.skip-js-search').val()
            + form.find('.shippingAddressTwo').val()
            + form.find('.shippingAddressCity').val()
            + form.find('.shippingState').val()
            + form.find('.shippingZipCode').val();

        if (loqateShippingAddressCheck) {
            loqateShippingAddressCheck = loqateShippingAddressCheck.toLowerCase();
            if (loqateCommercialShippingAddress) {
                loqateCommercialShippingAddress = loqateCommercialShippingAddress.toLowerCase();

                if ((loqateCommercialShippingAddress.indexOf(loqateShippingAddressCheck) > -1) || (loqateShippingAddressCheck.indexOf(loqateCommercialShippingAddress) > -1)) {
                    $('#isShippingAddressLoqateCommercial').val(true);
                }
            }
            if (loqatePOBoxShippingAddress) {
                loqatePOBoxShippingAddress = loqatePOBoxShippingAddress.toLowerCase();

                if ((loqatePOBoxShippingAddress.indexOf(loqateShippingAddressCheck) > -1) || (loqateShippingAddressCheck.indexOf(loqatePOBoxShippingAddress) > -1)) {
                    $('#isShippingAddressLoqatePOBox').val(true);
                }
            }
            if (loqateShippingAddress) {
                loqateShippingAddress = loqateShippingAddress.toLowerCase();
                if (loqateShippingAddress.toLowerCase() === loqateShippingAddressCheck.toLowerCase()) {
                    $('#isShippingAddressLoqate').val(true);
                }
            }
        }
    }
}

module.exports = {
    methods: {
        updateShippingAddressSelector: updateShippingAddressSelector,
        updateShippingAddressFormValues: updateShippingAddressFormValues,
        updateShippingMethods: updateShippingMethods,
        updateShippingSummaryInformation: updateShippingSummaryInformation,
        updatePLIShippingSummaryInformation: updatePLIShippingSummaryInformation,
        updateProductLineItemShipmentUUIDs: updateProductLineItemShipmentUUIDs,
        updateShippingInformation: updateShippingInformation,
        updateMultiShipInformation: updateMultiShipInformation,
        shippingFormResponse: shippingFormResponse,
        createNewShipment: createNewShipment,
        selectShippingMethodAjax: selectShippingMethodAjax,
        updateShippingMethodList: updateShippingMethodList,
        clearShippingForms: clearShippingForms,
        editMultiShipAddress: editMultiShipAddress,
        editOrEnterMultiShipInfo: editOrEnterMultiShipInfo,
        createErrorNotification: createErrorNotification,
        viewMultishipAddress: viewMultishipAddress,
        initializeShipping: initializeShipping,
        isValidGiftMessage: isValidGiftMessage,
        handleLoqateAddress: handleLoqateAddress,
        getValidCountries: getValidCountries,
        getGlobaleCountry: getGlobaleCountry,
        isValidCountry: isValidCountry,
        handleGlobaleCountry: handleGlobaleCountry,
        prepareSuggestedAddress: prepareSuggestedAddress
    },

    selectShippingMethod: function () {
        var baseObj = this;

        $('.shipping-method-list').change(function () {
            var $shippingForm = $(this).parents('form');
            var methodID = $(':checked', this).val();
            var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
            var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
            urlParams.shipmentUUID = shipmentUUID;
            urlParams.methodID = methodID;
            urlParams.isGift = $shippingForm.find('.gift').prop('checked');
            urlParams.giftMessage = $shippingForm.find('textarea[name$=_giftMessage]').val();

            var url = $(this).data('select-shipping-method-url');

            if (baseObj.methods && baseObj.methods.selectShippingMethodAjax) {
                baseObj.methods.selectShippingMethodAjax(url, urlParams, $(this));
            } else {
                selectShippingMethodAjax(url, urlParams, $(this));
            }
        });
    },

    toggleMultiship: function () {
        var baseObj = this;

        $('input[name="usingMultiShipping"]').on('change', function () {
            var url = $('.multi-shipping-checkbox-block form').attr('action');
            var usingMultiShip = this.checked;

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: { usingMultiShip: usingMultiShip },
                success: function (response) {
                    if (response.error) {
                        window.location.href = response.redirectUrl;
                    } else {
                        $('body').trigger('checkout:updateCheckoutView', {
                            order: response.order,
                            customer: response.customer
                        });

                        if ($('#checkout-main').data('customer-type') === 'guest') {
                            if (baseObj.methods && baseObj.methods.clearShippingForms) {
                                baseObj.methods.clearShippingForms(response.order);
                            } else {
                                clearShippingForms(response.order);
                            }
                        } else {
                            response.order.shipping.forEach(function (shipping) {
                                $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
                                    var form = el.form;
                                    if (!form) return;

                                    $(form).attr('data-address-mode', 'edit');
                                    var addressSelectorDropDown = $(form).find('.addressSelector option[value="ab_' + shipping.matchingAddressId + '"]');
                                    $(addressSelectorDropDown).prop('selected', true);
                                    $('input[name$=_isGift]', form).prop('checked', false);
                                    $('textarea[name$=_giftMessage]', form).val('');
                                    $(form).find('.gift-message').addClass('collapse');
                                });
                            });
                        }

                        if (usingMultiShip) {
                            $('body').trigger('shipping:selectMultiShipping', { data: response });
                        } else {
                            $('body').trigger('shipping:selectSingleShipping', { data: response });
                        }
                    }

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    selectSingleShipping: function () {
        $('body').on('shipping:selectSingleShipping', function () {
            $('.single-shipping .shipping-address').removeClass('d-none');
        });
    },

    selectMultiShipping: function () {
        var baseObj = this;

        $('body').on('shipping:selectMultiShipping', function (e, data) {
            $('.multi-shipping .shipping-address').addClass('d-none');

            data.data.order.shipping.forEach(function (shipping) {
                var element = $('.multi-shipping .card[data-shipment-uuid="' + shipping.UUID + '"]');

                if (shipping.shippingAddress) {
                    if (baseObj.methods && baseObj.methods.viewMultishipAddress) {
                        baseObj.methods.viewMultishipAddress($(element));
                    } else {
                        viewMultishipAddress($(element));
                    }
                } else {
                    /* eslint-disable no-lonely-if */
                    if (baseObj.methods && baseObj.methods.enterMultishipView) {
                        baseObj.methods.enterMultishipView($(element));
                    } else {
                        enterMultishipView($(element));
                    }
                    /* eslint-enable no-lonely-if */
                }
            });
        });
    },

    selectSingleShipAddress: function () {
        $('.single-shipping .addressSelector').on('change', function () {
            $('input[name="ignoreAddressValidation"]').val('no');
            hideAddressSuggestionSection();
            $('.submit-shipping').removeClass('d-none');

            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var element;
            $('.shipping-address-block').removeClass('customer-validation-error');
            Object.keys(attrs).forEach(function (attr) {
                element = attr === 'countryCode' ? 'country' : attr;
                $('[name$=' + element + ']:not(.disabled)', form).val(attrs[attr]);
            });
            $('[name$=stateCode]', form).trigger('change', ['nofocus']);
            if (shipmentUUID === 'new') {
                $(form).attr('data-address-mode', 'new');
                $(form).find('.shipping-address-block').removeClass('d-none');
            } else if (shipmentUUID === originalUUID) {
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                $(form).attr('data-address-mode', 'customer');
            } else {
                $(form).attr('data-address-mode', 'edit');
            }
        });
    },

    selectMultiShipAddress: function () {
        var baseObj = this;

        $('.multi-shipping .addressSelector').on('change', function () {
            var form = $(this).closest('form');
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var pliUUID = $('input[name=productLineItemUUID]', form).val();
            var createNewShipmentScoped = baseObj.methods && baseObj.methods.createNewShipment ? baseObj.methods.createNewShipment : createNewShipment;

            var element;
            Object.keys(attrs).forEach(function (attr) {
                if (attr === 'isGift') {
                    $('[name$=' + attr + ']', form).prop('checked', attrs[attr]);
                    $('[name$=' + attr + ']', form).trigger('change');
                } else {
                    element = attr === 'countryCode' ? 'country' : attr;
                    $('[name$=' + element + ']', form).val(attrs[attr]);
                }
            });

            if (shipmentUUID === 'new' && pliUUID) {
                var createShipmentUrl = $(this).attr('data-create-shipment-url');
                createNewShipmentScoped(createShipmentUrl, { productLineItemUUID: pliUUID })
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'new');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else if (shipmentUUID === originalUUID) {
                $('select[name$=stateCode]', form).trigger('change');
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                var url = $(form).attr('action');
                var serializedData = $(form).serialize();
                createNewShipmentScoped(url, serializedData)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'customer');
                        var $rootEl = $(form).closest('.shipping-content');
                        editMultiShipAddress($rootEl);
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else {
                var updatePLIShipmentUrl = $(form).attr('action');
                var serializedAddress = $(form).serialize();
                createNewShipmentScoped(updatePLIShipmentUrl, serializedAddress)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'edit');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            }
        });
    },

    updateShippingList: function () {
        var baseObj = this;

        /*
        shippingAddress_addressFields_address1
        shippingAddress_addressFields_city
        shippingAddress_addressFields_country
        shippingAddress_addressFields_postalCode
        */

        // Update on State are Country dropdown change
        $('select[name$="shippingAddress_addressFields_states_stateCode"], input[name$="shippingAddress_addressFields_postalCode"]')
            .on('change blur', function (e) {
                var stateCode = $(e.currentTarget.form).find('select[name$="shippingAddress_addressFields_states_stateCode"]').val();
                var postalCode = $(e.currentTarget.form).find('input[name$="shippingAddress_addressFields_postalCode"]').val();

                if ((stateCode !== undefined && stateCode.length > 0) ||
                    (postalCode !== undefined && postalCode.length > 0)) {
                    if (baseObj.methods && baseObj.methods.updateShippingMethodList) {
                        baseObj.methods.updateShippingMethodList($(e.currentTarget.form));
                    } else {
                        updateShippingMethodList($(e.currentTarget.form));
                    }
                }
            });
        $('input[name$="shippingAddress_addressFields_address1"], input[name$="shippingAddress_addressFields_address2"]').on('blur change', function (e) {
            var address1 = $(e.currentTarget.form).find('input[name$="shippingAddress_addressFields_address1"]').val();
            var address2 = $(e.currentTarget.form).find('input[name$="shippingAddress_addressFields_address2"]').val();
            var poBOXPattern = new RegExp('P([.]?(O|0)[.]?|ost|ostal).((O|0)ffice.)?Box{1}', 'i');
            var loqatePOBoxSelected = sessionStorage.getItem('loqatePOBoxSelected');
            sessionStorage.removeItem('loqatePOBoxSelected');
            if (loqatePOBoxSelected || (address1 && poBOXPattern.test(address1)) || (address2 && poBOXPattern.test(address2))) {
                $('.delay-shipping-disclaimer').removeClass('d-none');
                if ($('input[name$="dwfrm_shipping_shippingAddress_shippingMethodID"]').length > 1) {
                    setTimeout(function () {
                        $('select[name$="shippingAddress_addressFields_states_stateCode').change();
                    }, 500);
                }
            } else if ($('input[name$="dwfrm_shipping_shippingAddress_shippingMethodID"]').length === 1) {
                setTimeout(function () {
                    $('select[name$="shippingAddress_addressFields_states_stateCode').change();
                    $('.delay-shipping-disclaimer').addClass('d-none');
                }, 500);
            } else {
                $('.delay-shipping-disclaimer').addClass('d-none');
            }
            if (address1) {
                setTimeout(function () {
                    if ($('input[name$="shippingAddress_addressFields_postalCode"]').val().length > 0) {
                        $('input[name$="shippingAddress_addressFields_postalCode"]').change();
                    }
                }, 500);
            }
        });
    },

    updateDataAddressMode: function () {
        $('body').on('shipping:updateDataAddressMode', function (e, data) {
            $(data.form).attr('data-address-mode', data.mode);
        });
    },

    enterMultiShipInfo: function () {
        var baseObj = this;

        $('.btn-enter-multi-ship').on('click', function (e) {
            e.preventDefault();

            if (baseObj.methods && baseObj.methods.editOrEnterMultiShipInfo) {
                baseObj.methods.editOrEnterMultiShipInfo($(this), 'new');
            } else {
                editOrEnterMultiShipInfo($(this), 'new');
            }
        });
    },

    editMultiShipInfo: function () {
        var baseObj = this;

        $('.btn-edit-multi-ship').on('click', function (e) {
            e.preventDefault();

            if (baseObj.methods && baseObj.methods.editOrEnterMultiShipInfo) {
                baseObj.methods.editOrEnterMultiShipInfo($(this), 'edit');
            } else {
                editOrEnterMultiShipInfo($(this), 'edit');
            }
        });
    },

    saveMultiShipInfo: function () {
        var baseObj = this;

        $('.btn-save-multi-ship').on('click', function (e) {
            e.preventDefault();

            // Save address to checkoutAddressBook
            var form = $(this).closest('form');
            var $rootEl = $(this).closest('.shipping-content');
            var data = $(form).serialize();
            var url = $(form).attr('action');

            $rootEl.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data
            })
                .done(function (response) {
                    formHelpers.clearPreviousErrors(form);
                    if (response.error) {
                        if (response.fieldErrors && response.fieldErrors.length) {
                            response.fieldErrors.forEach(function (error) {
                                if (Object.keys(error).length) {
                                    formHelpers.loadFormErrors(form, error);
                                }
                            });
                        } else if (response.serverErrors && response.serverErrors.length) {
                            $.each(response.serverErrors, function (index, element) {
                                createErrorNotification(element);
                            });
                        } else if (response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                    } else {
                        // Update UI from response
                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer
                            }
                        );

                        if (baseObj.methods && baseObj.methods.viewMultishipAddress) {
                            baseObj.methods.viewMultishipAddress($rootEl);
                        } else {
                            viewMultishipAddress($rootEl);
                        }
                    }

                    if (response.order && response.order.shippable) {
                        $('button.submit-shipping').attr('disabled', null);
                    }

                    $rootEl.spinner().stop();
                })
                .fail(function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }

                    $rootEl.spinner().stop();
                });

            return false;
        });
    },

    cancelMultiShipAddress: function () {
        var baseObj = this;

        $('.btn-cancel-multi-ship-address').on('click', function (e) {
            e.preventDefault();

            var form = $(this).closest('form');
            var $rootEl = $(this).closest('.shipping-content');
            var restoreState = $rootEl.data('saved-state');

            // Should clear out changes / restore previous state
            if (restoreState) {
                var restoreStateObj = JSON.parse(restoreState);
                var originalStateCode = restoreStateObj.shippingAddress.stateCode;
                var stateCode = $('[name$=_stateCode]', form).val();

                if (baseObj.methods && baseObj.methods.updateShippingAddressFormValues) {
                    baseObj.methods.updateShippingAddressFormValues(restoreStateObj);
                } else {
                    updateShippingAddressFormValues(restoreStateObj);
                }

                if (stateCode !== originalStateCode) {
                    $('[data-action=save]', form).trigger('click');
                } else {
                    $(form).attr('data-address-mode', 'edit');
                    if (baseObj.methods && baseObj.methods.editMultiShipAddress) {
                        baseObj.methods.editMultiShipAddress($rootEl);
                    } else {
                        editMultiShipAddress($rootEl);
                    }
                }
            }

            return false;
        });
    },

    isGift: function () {
        $('.gift').on('change', function (e) {
            e.preventDefault();
            var form = $(this).closest('form');

            if (this.checked) {
                $(form).find('.gift-message').removeClass('collapse');
                $('.gift-message-btn').find('.icon').removeClass('plus-blue').addClass('minus-blue');
            } else {
                $(form).find('.gift-message').addClass('collapse');
                $(form).find('#giftMessage').val('');
                $('.gift-message-btn').find('.icon').removeClass('minus-blue').addClass('plus-blue');
            }
        });
    },
    isGiftWrapped: function () {
        $('.gift-wrap').on('change', function (e) {
            e.preventDefault();

            // Announce state change to screen readers immediately via live region
            var statusElement = $('#' + $(this).data('status-id'));
            var $label = $('label[for="' + $(this).attr('id') + '"]');
            var labelText = $label.clone().find('span').remove().end()
                .text()
                .trim();
            var priceText = $label.find('span.sr-only')
                .text()
                .trim();
            var giftWrapLabel = labelText + ' ' + priceText;

            const $checkbox = $(this);
            const form = $checkbox.closest('form');
            const giftWrapCheckbox = $checkbox.parents('.gift-wrap-checkbox');
            let $pliContainer = $checkbox.closest('.product-line-item');
            if (!$pliContainer.length) {
                $pliContainer = giftWrapCheckbox.closest('.gift-wrap-eligible-wrapper');
            }
            if (!$pliContainer.length) {
                $pliContainer = giftWrapCheckbox;
            }

            // Temporarily disable checkbox, block clicks, and show spinner to prevent race conditions / duplicate requests
            $checkbox.prop('disabled', true);
            giftWrapCheckbox.css({
                'pointer-events': 'none',
                'user-select': 'none'
            });
            $pliContainer.spinner().start();

            const unlockGiftWrap = function () {
                $checkbox.prop('disabled', false);
                $checkbox.css({
                    'pointer-events': '',
                    'user-select': ''
                });
                giftWrapCheckbox.css({
                    'pointer-events': '',
                    'user-select': ''
                });
                $pliContainer.spinner().stop();
                $('.veil').remove();
            };

            var isNotGiftWrapEligable = $('.gift-wrap-eligible').data('gift-wrap-eligible');
            var mixedGiftWrapEligable = $('.gift-wrap-eligible').data('gift-wrap-mixed');
            var productForm;
            if (this.checked) {
                // form.find('.gift-wrap-note').removeClass('d-none');
                if (isNotGiftWrapEligable === true) {
                    $('.gift-wrap').addClass('d-none');
                    // $('.gift-wrap-msg').addClass('d-none');
                    // $('.gift-product-msg').addClass('d-none');
                    // form.find('.gift-wrap-note').addClass('d-none');
                    // $('.not-gift-wrapped-items-msg').removeClass('d-none');
                } else if (isNotGiftWrapEligable === false && mixedGiftWrapEligable === false) {
                    $('.gift-wrap').removeClass('d-none');
                    // $('.gift-wrap-msg').addClass('d-none');
                    // form.find('.gift-wrap-note').removeClass('d-none');
                    // $('.not-gift-wrapped-items-msg').addClass('d-none');
                } else if (isNotGiftWrapEligable === false && mixedGiftWrapEligable === true) {
                    $('.gift-wrap').removeClass('d-none');
                    // $('.gift-wrap-msg').removeClass('d-none');
                    // form.find('.gift-wrap-note').removeClass('d-none');
                    // $('.not-gift-wrapped-items-msg').addClass('d-none');
                }
                productForm = {
                    pid: $(giftWrapCheckbox).data('gift-wrap-id'),
                    quantity: '1',
                    orderItemUuid: $(giftWrapCheckbox).data('orderitemuuid'),
                    isGiftWrap: true

                };
                $.ajax({
                    url: $(giftWrapCheckbox).data('action-addproduct'),
                    method: 'POST',
                    data: productForm,
                    success: function (response) {
                        $(giftWrapCheckbox).data('pliuuid', response.pliUUID);
                        $(giftWrapCheckbox).data('action-removeproductlineitem', response.removeGiftWrapUrl);

                        // Hide order total summary from screen readers during update
                        $('.card.order-total-summary').attr('aria-hidden', 'true');

                        if (response.cart && response.cart.totals) {
                            summaryHelpers.updateTotals(response.cart.totals);
                        } else if (response.order && response.order.totals) {
                            summaryHelpers.updateTotals(response.order.totals);
                        }

                        if (response.order && response.order.shipping) {
                            summaryHelpers.updateOrderProductSummaryInformation(response.order);
                            response.order.shipping.forEach(function (shipping) {
                                updateShippingInformation(
                                    shipping,
                                    response.order,
                                    response.customer,
                                    response.options
                                );
                            });

                            updateGiftWrapSection(response);
                        }

                        // Update live region with totals information
                        if (statusElement.length && response.cart && response.cart.totals) {
                            var totals = response.cart.totals;

                            var announcement = giftWrapLabel + ' added. ' +
                                'Tax ' + totals.totalTax + '. ' +
                                'Gift Box ' + totals.giftWrapPrice + '. ' +
                                'Order Total ' + totals.grandTotal;
                            statusElement.text(announcement);

                            // Remove aria-hidden after announcement
                            setTimeout(function () {
                                $('.card.order-total-summary').removeAttr('aria-hidden');
                            }, 100);
                        }

                        if (response.error) {
                            createErrorNotification(response.errorMessage);
                        }

                        // response.cart.items.forEach(function (item) {
                        //     if (response.cart.giftWrapId && item.notGiftWrapEligible !== null && item.notGiftWrapEligible === true && item.UUID !== response.cart.giftWrapId) {
                        //         $('.gift-product-msg-' + item.UUID).removeClass('d-none');
                        //     } else {
                        //         $('.gift-product-msg-' + item.UUID).addClass('d-none');
                        //     }
                        // });
                        if (!response.cart.hasGiftWrap && !response.cart.hasGiftMessage) {
                            $('.gift-wrap-msg').addClass('d-none');
                            form.find('.gift-wrap-note').addClass('d-none');
                            $('.gift-wrap').prop('checked', false);
                            $('.edit-gift-options-button').addClass('d-none');
                        } else {
                            $('.edit-gift-options-button').removeClass('d-none');
                        }
                        $('body').trigger('giftcard:clear');
                    },
                    error: function (err) {
                        $checkbox.prop('checked', false);
                        if (err.responseJSON !== undefined && err.responseJSON.errorMessage !== undefined &&
                            err.responseJSON.errorMessage.length) {
                            createErrorNotification(err.responseJSON.errorMessage);
                        }
                        unlockGiftWrap();
                    },
                    complete: function () {
                        unlockGiftWrap();
                    }
                });
            } else {
                form.find('.gift-wrap-note').addClass('d-none');
                // $('.gift-product-msg').addClass('d-none');
                $('.gift-wrap-msg').addClass('d-none');
                $.ajax({
                    url: $(giftWrapCheckbox).data('action-removeproductlineitem'),
                    method: 'GET',
                    success: function (response) {
                        // Hide order total summary from screen readers during update
                        $('.card.order-total-summary').attr('aria-hidden', 'true');

                        if (response.order && response.order.totals) {
                            summaryHelpers.updateTotals(response.order.totals);
                        }

                        if (response.order && response.order.shipping) {
                            summaryHelpers.updateOrderProductSummaryInformation(response.order);
                            response.order.shipping.forEach(function (shipping) {
                                updateShippingInformation(
                                    shipping,
                                    response.order,
                                    response.customer,
                                    response.options
                                );
                            });

                            updateGiftWrapSection(response);
                        }

                        var address1Info = $('input[name$="shippingAddress_addressFields_address1"]').val();
                        var address2Info = $('input[name$="shippingAddress_addressFields_address2"]').val();
                        var POBOXPattern = new RegExp('P([.]?(O|0)[.]?|ost|ostal).((O|0)ffice.)?Box{1}', 'i');
                        if ((address1Info && POBOXPattern.test(address1Info)) || (address2Info && POBOXPattern.test(address2Info))) {
                            $('.delay-shipping-disclaimer').removeClass('d-none');
                        } else {
                            $('.delay-shipping-disclaimer').addClass('d-none');
                        }

                        var hasGiftWrap = !!(response.order && response.order.hasGiftWrap);
                        hasGiftWrap = response.cart && response.cart.hasGiftMessage ? true : hasGiftWrap;
                        if (!hasGiftWrap) {
                            $('.edit-gift-options-button').addClass('d-none');
                        }

                        // Update live region with totals information
                        if (statusElement.length && response.order && response.order.totals) {
                            var totals = response.order.totals;

                            var announcement = giftWrapLabel + ' removed. ' +
                                'Tax ' + totals.totalTax + '. ' +
                                'Order Total ' + totals.grandTotal;
                            statusElement.text(announcement);

                            // Remove aria-hidden after announcement
                            setTimeout(function () {
                                $('.card.order-total-summary').removeAttr('aria-hidden');
                            }, 100);
                        }

                        if (response.error) {
                            createErrorNotification(response.errorMessage);
                        }
                    },
                    error: function (err) {
                        $checkbox.prop('checked', true);
                        if (err.responseJSON !== undefined && err.responseJSON.errorMessage !== undefined &&
                            err.responseJSON.errorMessage.length) {
                            createErrorNotification(err.responseJSON.errorMessage);
                        }
                        unlockGiftWrap();
                    },
                    complete: function () {
                        unlockGiftWrap();
                    }
                });
            }
        });
    },
    validateGiftMessage: function () {
        $(document).on('blur', '#giftMessage', isValidGiftMessage);
    },
    keyboardSelectShippingOption: function () {
        $(document).on('keydown', '.shipping-option-wrapper', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                var $focusedRadioButton = $(event.target).find('.custom-control-input');
                if ($focusedRadioButton.length) {
                    $focusedRadioButton.prop('checked', true).trigger('change');
                    window.selectedShippingMethodID = $focusedRadioButton.attr('id');
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                var $nextOption = $(this).nextAll('.shipping-option-wrapper').first();
                if ($nextOption.length) {
                    $nextOption.focus();
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                var $prevOption = $(this).prevAll('.shipping-option-wrapper').first();
                if ($prevOption.length) {
                    $prevOption.focus();
                }
            }
        });

        $(document).on('updateShippingMethods', function () {
            if (window.selectedShippingMethodID) {
                var $fieldset = $('fieldset.shipping-method-block');
                var $selectedOption = $fieldset.find('#' + window.selectedShippingMethodID).closest('.shipping-option-wrapper');

                if ($selectedOption.length) {
                    $selectedOption.focus();
                }
            }
        });
    },
    handleShipmentGroupFocus: function () {
        // Handle focus management for shipment group collapse buttons
        // When the collapse is shown, move focus to the expanded content
        $(document).on('shown.bs.collapse', '.shipment-group-items', function () {
            // Move focus to the expanded region
            $(this).focus();
        });
    },
    syncAddressSearchFieldWithAddress1: function () {
        // update loqate search field accordingly in order to prevent validation error when user enters address manually instead of using search
        $(document).on('input', 'input[name$="shippingAddress_addressFields_address1"]', function () {
            var address1Value = $(this).val();
            var searchField = $(this.form).find('#search-addressDefault');
            if (searchField.length) {
                searchField.val(address1Value);
            }
        });
    }
};
